// Module
var code = "<div class=\"api\" data-bind=\"component: { name: 'placeholder', params: 'API output' }\"></div>\n";
// Exports
module.exports = code;